/** @jsx jsx */
import isPropValid from '@emotion/is-prop-valid';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

import { StyledButton, greyButton, primaryCss, type ButtonProps } from './Button';

const linkStyles = css`
  box-sizing: border-box;
  text-decoration: none;
  line-height: 35px;
`;
const StyledExternalLink = styled(StyledButton.withComponent('a'))`
  ${linkStyles};
`;
const StyledLink = styled(StyledButton.withComponent(Link), { shouldForwardProp: isPropValid })`
  ${linkStyles};
`;

interface ButtonLinkProps {
  href?: string;
  isExternal?: boolean;
  target?: string;
  to?: string;
}

const ButtonLink = (props: ButtonLinkProps & ButtonProps) => {
  const { dataAnalytics, dataPendo, isExternal, ...rest } = props;
  let LinkComponent;

  if (isExternal) LinkComponent = StyledExternalLink;
  else LinkComponent = StyledLink;

  return (
    <LinkComponent
      className={props.className}
      data-analytics={dataAnalytics}
      data-heap={dataAnalytics}
      data-pendo={dataPendo}
      {...rest}
    >
      {props.children}
    </LinkComponent>
  );
};

export const PrimaryLink = styled(ButtonLink)`
  ${primaryCss};
`;

export const GreyPrimaryAlternativeLink = styled(ButtonLink)`
  ${greyButton};
`;
